var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tk",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tk-outer"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "tk-rect",
    x: 1,
    y: 0.5,
    width: 39,
    height: 39,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "tk-inner"
  }, /*#__PURE__*/React.createElement("path", {
    id: "tk-path",
    d: "M11.3749 19.1352C16.7436 16.7962 20.3236 15.2541 22.1148 14.5091C27.2292 12.3819 28.2919 12.0123 28.9846 12.0001C29.1369 11.9974 29.4776 12.0352 29.6982 12.2142C29.8845 12.3654 29.9358 12.5696 29.9603 12.713C29.9848 12.8563 30.0154 13.1828 29.9911 13.438C29.714 16.35 28.5147 23.4167 27.9046 26.6783C27.6465 28.0583 27.1382 28.5211 26.6461 28.5663C25.5766 28.6648 24.7645 27.8596 23.7287 27.1806C22.1078 26.1181 21.1921 25.4567 19.6188 24.4199C17.8005 23.2217 18.9792 22.5631 20.0155 21.4869C20.2866 21.2052 24.9987 16.9192 25.0899 16.5304C25.1013 16.4818 25.1119 16.3005 25.0042 16.2048C24.8965 16.1091 24.7376 16.1418 24.6229 16.1678C24.4604 16.2047 21.871 17.9162 16.8549 21.3022C16.1199 21.8069 15.4542 22.0528 14.8577 22.0399C14.2001 22.0257 12.9353 21.6682 11.995 21.3625C10.8417 20.9876 9.92503 20.7894 10.0048 20.1527C10.0464 19.8211 10.5031 19.4819 11.3749 19.1352Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTk);
export default __webpack_public_path__ + "static/media/tk.67dc31a68f6636344e9a8a7e29c70d9d.svg";
export { ForwardRef as ReactComponent };